import { StyleProp, TextStyle, ViewStyle } from 'react-native';
import { MBTextBody1 } from '@shared/components/typography';
import { TextField } from '@shared/data/entity/fields/TextField';
import { grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: TextField;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  numberOfLines?: number;
}

const defaultStyle: StyleProp<ViewStyle> = {
  paddingVertical: grid(1),
};

const multilineStyle: StyleProp<TextStyle> = {
  // @ts-ignore
  whiteSpace: 'pre-wrap',
};

export function TextCollectionViewField({
  field,
  style,
  textStyle,
  numberOfLines = field.multiline ? 4 : 2,
}: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={[defaultStyle, style]}>
      <MBTextBody1
        numberOfLines={numberOfLines}
        style={[field.multiline && multilineStyle, textStyle]}
      >
        {field.value}
      </MBTextBody1>
    </CardCollectionViewFieldContainer>
  );
}
